import useEmblaCarousel from 'embla-carousel-react';
import * as React from 'react';

import { useDevice, useDotButton, useWindowSize } from '../hooks.tsx';

import './section-card-wrapper.css';

interface SectionCardWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {}

const SectionCardWrapper = React.forwardRef<
  HTMLDivElement,
  SectionCardWrapperProps
>(({ children, ...props }, ref) => {
  const dimensions = useWindowSize();
  const device = useDevice(dimensions);

  const [internalList] = React.useState(React.Children.toArray(children));
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  if (!children) return;

  return device === 'desktop' ? (
    <div className="section-card-wrapper" ref={ref} {...props}>
      <div className="section-card-wrapper-layout">{children}</div>
    </div>
  ) : (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {internalList.map((internalItem, index) => (
            <div key={`carousel-item-${index}`} className="embla__slide">
              {internalItem}
            </div>
          ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <button
              key={`carousel-indicator-${index}`}
              type="button"
              onClick={() => onDotButtonClick(index)}
              className={`embla__dot ${
                index === selectedIndex ? 'embla__dot--selected' : ''
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export { SectionCardWrapper };
